import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

import { IFolder } from '~/utils/interface/folder';
import { handleGetFilesFromFolder } from './folderThunk';
import { IJobFile } from '~/utils/interface/job';

export interface CustomerState {
  filter: IFilter;

  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;

  selectedIds: Array<string>;

  openAlertDelete: boolean;

  menuSelectedId: string | undefined;

  filterFile: ICustomerFileFilter;
  folders: Array<IFolder>;
  fileId: string;
  files: Array<IJobFile>;
}

interface ICustomerFileFilter {
  page?: number;
  limit?: number;
  selectedTags?: Array<string>;
}
interface IFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: CustomerState = {
  files: [],
  fileId: '',
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },

  selectedIds: [],

  openAlertDelete: false,

  menuSelectedId: undefined,

  filterFile: {
    page: 1,
    limit: ROWS_PER_PAGE,
  },
  folders: [],
};

const folderSlice = createSlice({
  name: 'folder',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilterFile(state, action: PayloadAction<ICustomerFileFilter>) {
      state.filterFile = { ...state.filterFile, ...action.payload };
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },

    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },

    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },

    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
    changeFileId(state, action: PayloadAction<string>) {
      state.fileId = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(handleGetFilesFromFolder.fulfilled, (state, action) => {
      state.files = [...action.payload.responses];

      state.currentPage = action.payload.pagination.page;

      state.totalPages = action.payload.pagination.totalPages;
      state.needRefreshData = false;
    });
  },
});

export const folderActions = folderSlice.actions;

const folderReducer = folderSlice.reducer;
export default folderReducer;
